module.exports = {
	"lang" : "en",
}
